<template>
	<div class="top w">
		<div class="nav">
			<ul>
				<li v-for="(value,key,index) in cat_list" :key='index'>
					<div class="ttshop-navtitle">
						<div class="ttshop-nav-icon">
							<img :src="value.pc_icon"  alt="">
						</div>
						<span @click="qylist(value.id)" v-text="value.name"></span>
					</div>
					<div class="ttshop-navsecond">
						<div class="ttshop-navsecondcon clearfloat">
							<div class="ttshop-navsecondleft">
								<div class="ttshop-navsecondbut">
									<div class="ttshop-navseconlist clearfloat" v-for="(item,index) in value.child" :key="index">
										<span  @click="qylist(item.id)" v-text="item.name"></span>
										<ul class="clearfloat">
											<li v-for="(items,index) in item.child" :key="index">
												<span @click="qylist(items.id)" v-text="items.name"></span>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div class="ttshop-navsecondright">
								<div class="ttshop-navbutton">
									<div class="ttshop-navbuttonlist">
										<img :src="value.big_pic_url" alt="">
									</div>
								</div>
							</div>
						</div>
					</div>
				</li>
			</ul>
		</div>
		<div class="banner">
			<div class="swiper-container swiper-banner">
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="(value,key,index) in banner_list" :key="index">
						<img :src="value" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		Swiper,
		SwiperSlide
	} from "vue-awesome-swiper";
	export default {
		props: {
			banner_list: {
				type: Array,
				default () {
					return {};
				},
			},
			cat_list: {
				type: Array,
				default () {
					return {};
				},
			},
		},
		data() {
			return {
				route_url: this.$route.params.route_url,
				// enterprise_name: this.$store.state.qycg_user.nickname,
				user: {},
				// banner_list: [], //banner图列表
				class_list: [], //全部分类列表
				login: true,
				error_img: 'this.src="' + require("../../../../assets/images/lodingsb.svg") + '"', //图片加载失败
			};
		},
		created() {
			// this.common.loginType(this);
			// console.log(this.banner_list,"banner_list")
		},
		watch: {

		},
		mounted() {
			new Swiper(".swiper-banner", {
				autoplay: {
					delay: 2500,
					stopOnLastSlide: false,
					disableOnInteraction: true,
				},
				loop: false, // 循环模式选项
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				effect: "fade",
				observer: true,
				observeParents: true,
			});
		},
		methods: {
			qylist(id){
				this.$router.push({
					path: this.common.qycgrouter(this) + "/qycglist",
					query: {id},
				});
			},
			
			// 全部分类
			// classList() {
			// 	this.$api.classIfication({
			// 		shop_type: 'qycg',
			// 		access_token: this.$store.state.qycg_user.access_token,
			// 	}).then((res) => {
			// 		if (res.code == 0) {
			// 			this.class_list = res.data;
			// 		}
			// 	}).catch((err) => {
			// 		// console.log(err)
			// 	});
			// },
			
		}
	};
</script>

<style lang="scss" scoped>
	.swiper-banner {
		width: 980px;
		height: 484px;
	}

	.swiper-slide {
		height: 100%;
		width: 100%;
	}

	.top {
		margin-top: 10px !important;
		display: flex;
		justify-content: space-between;

		.nav {
			height: 484px;
			width: 190px;
			background-color: #fff;
			box-sizing: border-box;
			position: relative;

			&:hover {
				.nav-box {
					opacity: 0.8;
					filter: alpha(opacity=80);
				}
			}

			li {
				width: 100%;

				.ttshop-navtitle {
					position: relative;
					width: 100%;
					box-sizing: border-box;
					height: 44px;
					line-height: 44px;
					padding-left: 40px;
					cursor: pointer;

					.ttshop-nav-icon {
						width: 18px;
						height: 18px;
						float: left;
						position: absolute;
						left: 16px;
						top: 13px;
					}

					span {
						font-size: 14px;
						color: #333;
						cursor: pointer;
						position: relative;
						margin-right: 6px;
						transition: all 0.4s;

						&::before {
							content: "/";
							font-size: 12px;
							color: #333;
							position: absolute;
							top: -1px;
							right: -6px;
							line-height: 1.5;
						}

						&:hover {
							color: #ff0e25;
						}

						&:last-child::before {
							display: none;
						}
					}

					&:hover {
						box-shadow: 0 0 10px 0 rgba(0, 0, 0, .1);
					}
				}

				&:hover {
					.ttshop-navsecond {
						display: block;
					}
				}

				.ttshop-navsecond {
					display: none;
					position: absolute;
					top: 0px;
					left: 190px;
					width: 1000px;
					min-height: 484px;
					border-left: 1px solid #f3f3f3;
					padding: 20px 10px 20px 32px;
					box-sizing: border-box;
					background: #fff;
					z-index: 1000;
					box-shadow: 0 0 10px 0 rgba(0, 0, 0, .1);

					.ttshop-navsecondcon {
						width: 100%;

						.ttshop-navsecondleft {
							float: left;
							width: 740px;

							.ttshop-navseconduptitle {
								width: 100%;
								margin-bottom: 20px;

								span {
									float: left;
									font-size: 12px;
									color: #ff0e25;
									background: #fff0f1;
									padding: 6px 12px;
									line-height: 12px;
									box-sizing: border-box;
									margin-right: 16px;
									transition: 0.5s;
									-moz-transition: 0.5s;
									-webkit-transition: 0.5s;
									-o-transition: 0.5s;
									cursor: pointer;
									border-radius: 2px;

									&:last-child {
										margin-right: 0;
									}

									&:hover {
										background: #ff0e25;
										color: #fff;
									}
								}
							}

							.ttshop-navsecondbut {
								width: 100%;

								.ttshop-navseconlist {
									width: 100%;
									margin-bottom: 15px;

									&:last-child {
										margin-bottom: 0;
									}

									span {
										float: left;
										width: 60px;
										font-size: 14px;
										color: #333;
										font-weight: 600;
										transition: 0.5s;
										-moz-transition: 0.5s;
										-webkit-transition: 0.5s;
										-o-transition: 0.5s;
										cursor: pointer;
										margin-right: 30px;
										text-align: left;

										&:hover {
											color: #ff0e25;
										}
									}

									ul {
										float: left;
										max-width: 650px;

										li {
											width: auto;
											float: left;
											font-size: 12px;
											color: #999;
											font-weight: 400;
											line-height: 1.5;
											margin-right: 12px;

											span {
												float: none;
												width: auto;
												margin-right: 0;
												font-size: 14px;
												color: #999;
												font-weight: 400;
												transition: 0.5s;
												-moz-transition: 0.5s;
												-webkit-transition: 0.5s;
												-o-transition: 0.5s;

												&:hover {
													color: #ff0e25;
												}
											}
										}
									}
								}
							}
						}

						.ttshop-navsecondright {
							float: right;
							width: 175px;

							.ttshop-navbutton {
								width: 100%;

								.ttshop-navbuttonlist {
									width: 100%;
									height: 215px;
									margin-bottom: 1px;
									cursor: pointer;

									&:last-child {
										margin-bottom: 0;
									}

									img {
										width: 100%;
										display: block;
									}
								}
							}
						}
					}
				}
			}

			.nav-box {
				width: 800px;
				height: 484px;
				background: #ebebeb;
				position: absolute;
				left: 190px;
				top: 0;
				z-index: 10;
				opacity: 0;
				transition: 0.35s;
				-moz-transition: 0.35s;
				-webkit-transition: 0.35s;
				-o-transition: 0.35s;
			}
		}

		.banner {
			width: 980px;
			height: 484px;
		}

		.user {
			height: 484px;
			width: 190px;
			background-color: #fff;

			.user-t {
				height: 154px;
				border-bottom: 1px solid #ebebeb;
				padding-top: 32px;
				box-sizing: border-box;

				.ttshop-tloding {
					width: 100%;

					.ttshop-tlodingimg {
						width: 36px;
						height: 36px;
						border-radius: 50%;
						margin: 0 auto 12px;

						img {
							display: block;
							width: 100%;
							height: 100%;
							object-fit: cover;
							border-radius: 50%;
						}
					}

					.ttshop-userloidng {
						width: 100%;
						display: block;
						margin-bottom: 18px;

						.ttshop-userloidngs {
							display: table;
							margin: 0 auto;

							a {
								float: left;
								font-size: 12px;
								color: #333;
								margin-right: 10px;
								position: relative;
								cursor: pointer;
								transition: 0.5s;
								-moz-transition: 0.5s;
								-webkit-transition: 0.5s;
								-o-transition: 0.5s;

								&::before {
									content: "";
									width: 1px;
									height: 12px;
									background: #333;
									position: absolute;
									top: 3px;
									right: -5px;
								}

								&:hover {
									color: #ff0e25;
								}

								&:last-child {
									margin-right: 0;
								}

								&:last-child::before {
									display: none;
								}
							}
						}
					}

					.ttshop-userloidngover {
						width: 100%;
						margin-bottom: 18px;

						.ttshop-userloidngovers {
							display: table;
							margin: 0 auto;

							p {
								float: left;
								font-size: 12px;
								color: #333;
								position: relative;
								transition: 0.5s;
								-moz-transition: 0.5s;
								-webkit-transition: 0.5s;
								-o-transition: 0.5s;
								margin-right: 10px;

								&::before {
									content: "";
									width: 1px;
									height: 12px;
									background: #333;
									position: absolute;
									top: 3px;
									right: -5px;
								}

								a {
									font-size: 12px;
									color: #ff0e25;
								}
							}

							strong {
								float: left;
								font-size: 12px;
								color: #333;
								font-weight: 400;
								cursor: pointer;
								transition: 0.5s;
								-moz-transition: 0.5s;
								-webkit-transition: 0.5s;
								-o-transition: 0.5s;

								&:hover {
									color: #ff0e25;
								}
							}
						}
					}

					.ttshop-newuser {
						width: 100%;

						.ttshop-newusers {
							display: table;
							margin: 0 auto;

							div {
								cursor: pointer;
								display: block;
								float: left;
								width: 77px;
								height: 26px;
								border-radius: 25px;
								font-size: 12px;
								color: #fff;
								text-align: center;
								line-height: 26px;
								background: #ff0e25;
								margin-right: 12px;
								transition: 0.5s;
								-moz-transition: 0.5s;
								-webkit-transition: 0.5s;
								-o-transition: 0.5s;

								&:hover {
									box-shadow: 0 0 10px rgba(255, 14, 37, 0.3);
								}

								&:last-child {
									background: #ff9010;
									margin-right: 0;
								}

								&:last-child:hover {
									box-shadow: 0 0 10px rgba(255, 144, 16, 0.3);
								}
							}
						}
					}
				}
			}

			.user-c {
				height: 170px;
				border-bottom: 1px solid #ebebeb;
				padding: 0 12px 8px 12px;
				box-sizing: border-box;

				.user-c-title {
					height: 50px;
					display: flex;
					justify-content: space-between;
					align-items: center;

					.title-l {
						font-size: 14px;
						color: #333333;
					}

					.title-r {
						color: #999999;
						transition: color 0.3s;
					}

					.title-r:hover {
						color: #ff0e25;
					}
				}

				.user-c-list {

					.list-item {
						display: flex;
						align-items: center;
						margin-bottom: 8px;

						.list-item-l {
							width: 36px;
							height: 20px;
							line-height: 20px;
							background: #fff0f1;
							border-radius: 3px;
							color: #ff0e25;
							display: flex;
							justify-content: center;
							align-content: center;
							flex-shrink: 0;
						}

						.list-item-r {
							width: 121px;
							margin-left: 8px;
							color: #666666;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
						}
					}
				}
			}

			.user-b {
				height: 154px;
				display: flex;
				flex-wrap: wrap;

				.user-b-item {
					width: 50%;
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;

					img {
						height: 32px;
						width: 32px;
					}

					span {
						margin-top: 8px;
					}
				}
			}
		}
	}
</style>
